import {
  activityGlyph,
  puzzleGlyph,
  usersGlyph,
  workGlyph,
} from 'Assets/_Legacy/BlockchainPage/icons'

export const WHY_CARDS = [
  {
    id: 'whyCard001',
    icon: puzzleGlyph,
    title: 'Solution',
    text: 'Building blockchain solutions since 2017 and working with multiple networks including Ethereum (ERC20), Binance Smart Chain (BSC), Solana (SOL), Cardano (ADA) and Polkadot (DOT).',
  },
  {
    id: 'whyCard002',
    icon: workGlyph,
    title: 'Portfolio',
    text: 'Built a portfolio of strong products that resemble almost any aspect of dApp development.',
  },
  {
    id: 'whyCard003',
    icon: usersGlyph,
    title: 'Personnel',
    text: 'Cross-train personnel to work with both Cloud and Blockchain solutions to gain the best out of two worlds.',
  },
  {
    id: 'whyCard004',
    icon: activityGlyph,
    title: 'Trend',
    text: 'Constantly stay in trend with modern developments, security upgrades and community news to bring the best in class solutions.',
  },
]
